import React, { MutableRefObject, useEffect, useState } from 'react'
import { BodyDrawer } from './styled'
import { HeaderDrawer } from '../CustomUi/headerGaveta'
import { Render } from '../CustomUi/render'
import Carregando from '../CustomUi/loading'
import Tabs from '../Tabs'
import { faGear, faUser, faUsers } from '@fortawesome/free-solid-svg-icons'
import { FormDadosClientes } from './components/formDados'
import { UploadFile } from 'antd'
import { UploadChangeParam } from 'antd/lib/upload'
import { UploadRequestOption } from 'rc-upload/lib/interface'
import { FormRepresentantesServiço } from './components/formRepresentantes'
import { Dayjs } from 'dayjs'
import { destroyAlert, errorAlert, loadingAlert } from '../../utils/alert'
import { listEscolaridade, listEstadoCivil, listProfissao, listUf } from '../../services/Afins'
import { AxiosResponse } from 'axios'
import { getEquipe, TypesEquipe } from '../../services/Equipe'
import { useGetCep, useGetCnpj } from '../../services/buscarCNPJ'
import ClienteModulo from '../ClienteModulos'

interface PropsFormCliente {
  tab_selecionado_atual: string
  setTab_selecionado_atual: React.Dispatch<React.SetStateAction<string>>
  tipo_cliente: string
  setTipo_cliente: React.Dispatch<React.SetStateAction<string>>
  nome: string
  setNome: React.Dispatch<React.SetStateAction<string>>
  nascimento: Dayjs | null
  setNascimento: React.Dispatch<React.SetStateAction<Dayjs | null>>
  cpf: string
  setCpf: React.Dispatch<React.SetStateAction<string>>
  rg: string
  setRg: React.Dispatch<React.SetStateAction<string>>
  orgao_expedidor: string
  setOrgao_expedidor: React.Dispatch<React.SetStateAction<string>>
  sexo: string
  setSexo: React.Dispatch<React.SetStateAction<string>>
  nacionalidade: string
  setNacionalidade: React.Dispatch<React.SetStateAction<string>>
  escolaridade: string
  setEscolaridade: React.Dispatch<React.SetStateAction<string>>
  escolaridadeId: number
  setEscolaridadeId: React.Dispatch<React.SetStateAction<number>>
  estado_civil: string
  setEstado_civil: React.Dispatch<React.SetStateAction<string>>
  estado_civilId: number
  setEstado_civilId: React.Dispatch<React.SetStateAction<number>>
  profissao: string
  setProfissao: React.Dispatch<React.SetStateAction<string>>
  profissaoId: number
  setProfissaoId: React.Dispatch<React.SetStateAction<number>>
  celular: string
  setCelular: React.Dispatch<React.SetStateAction<string>>
  fone_fixo: string
  setFone_fixo: React.Dispatch<React.SetStateAction<string>>
  email: string
  setEmail: React.Dispatch<React.SetStateAction<string>>
  estado: string
  setEstado: React.Dispatch<React.SetStateAction<string>>
  estadoId: number
  setEstadoId: React.Dispatch<React.SetStateAction<number>>
  cidade: string
  setCidade: React.Dispatch<React.SetStateAction<string>>
  cidadeId: number
  setCidadeId: React.Dispatch<React.SetStateAction<number>>
  cep: string
  setCep: React.Dispatch<React.SetStateAction<string>>
  logradouro: string
  setLogradouro: React.Dispatch<React.SetStateAction<string>>
  numero: string
  setNumero: React.Dispatch<React.SetStateAction<string>>
  bairro: string
  setBairro: React.Dispatch<React.SetStateAction<string>>
  complemento: string
  setComplemento: React.Dispatch<React.SetStateAction<string>>
  razao_social: string
  setRazao_social: React.Dispatch<React.SetStateAction<string>>
  cnpj: string
  setCnpj: React.Dispatch<React.SetStateAction<string>>
  ie: string
  setIe: React.Dispatch<React.SetStateAction<string>>
  outros: string
  setOutros: React.Dispatch<React.SetStateAction<string>>
  update: number
  statusCliente: number
  clienteSelect: number
  loadingForm: boolean
  uploadLogo: MutableRefObject<any>
  handleChangeUpload: (info: UploadChangeParam<UploadFile<any>>) => void
  dummyRequest: (options: UploadRequestOption<any>) => void
  onPreview: (file: UploadFile<any>) => void
  fileListImg: any
  onRemoveLogo: (file: UploadFile<any>) => boolean | void | Promise<boolean | void>
  previewVisibleImg: boolean
  setPreviewVisibleImg: React.Dispatch<React.SetStateAction<boolean>>
  imageUrl: string
  onChangeUpload: (info: UploadChangeParam<UploadFile<any>>) => void
  dummyRequestAss: (options: UploadRequestOption<any>) => void
  handlePreviewImage: (file: UploadFile<any>) => void
  onRemoveAssinatura: (file: UploadFile<any>) => boolean | void | Promise<boolean | void>
  fileList: any
  uploadAssinatura: MutableRefObject<any>
  nome_usuario: string
  setNome_usuario: React.Dispatch<React.SetStateAction<string>>
  nome_usuarioId: number
  setNome_usuarioId: React.Dispatch<React.SetStateAction<number>>
  outros_solicitantes: string
  setOutros_solicitantes: React.Dispatch<React.SetStateAction<string>>
  porcentagem: string
  setPorcentagem: React.Dispatch<React.SetStateAction<string>>
  representante_legal: boolean
  setRepresentante_legal: React.Dispatch<React.SetStateAction<boolean>>
  observacoes: string
  setObservacoes: React.Dispatch<React.SetStateAction<string>>
  list_representantes: any[]
  setList_representantes: React.Dispatch<React.SetStateAction<any[]>>
  dataCity: any[]
  dataCityFilter: any[]
  setDataCityFilter: React.Dispatch<React.SetStateAction<any[]>>
  loading: boolean
  addRepresentante: Function
  editarRepresentante: Function
  handleChangeCidadeUf: Function
  editar: boolean
  listRepresentante: Function
  loadingRepresentante: boolean
}

export const FormCliente: React.FC<PropsFormCliente> = ({
  tab_selecionado_atual,
  setTab_selecionado_atual,
  tipo_cliente,
  setTipo_cliente,
  nome,
  setNome,
  nascimento,
  setNascimento,
  cpf,
  setCpf,
  rg,
  setRg,
  orgao_expedidor,
  setOrgao_expedidor,
  sexo,
  setSexo,
  nacionalidade,
  setNacionalidade,
  escolaridade,
  setEscolaridade,
  escolaridadeId,
  setEscolaridadeId,
  estado_civil,
  setEstado_civil,
  estado_civilId,
  setEstado_civilId,
  profissao,
  setProfissao,
  profissaoId,
  setProfissaoId,
  celular,
  setCelular,
  fone_fixo,
  setFone_fixo,
  email,
  setEmail,
  estado,
  setEstado,
  estadoId,
  setEstadoId,
  cidade,
  setCidade,
  cidadeId,
  setCidadeId,
  cep,
  setCep,
  logradouro,
  setLogradouro,
  numero,
  setNumero,
  bairro,
  setBairro,
  complemento,
  setComplemento,
  razao_social,
  setRazao_social,
  cnpj,
  setCnpj,
  ie,
  setIe,
  outros,
  setOutros,
  update,
  statusCliente,
  clienteSelect,
  loadingForm,
  uploadLogo,
  handleChangeUpload,
  dummyRequest,
  onPreview,
  fileListImg,
  onRemoveLogo,
  previewVisibleImg,
  setPreviewVisibleImg,
  imageUrl,
  onChangeUpload,
  fileList,
  dummyRequestAss,
  handlePreviewImage,
  onRemoveAssinatura,
  uploadAssinatura,
  nome_usuario,
  setNome_usuario,
  nome_usuarioId,
  setNome_usuarioId,
  outros_solicitantes,
  setOutros_solicitantes,
  porcentagem,
  setPorcentagem,
  representante_legal,
  setRepresentante_legal,
  observacoes,
  setObservacoes,
  list_representantes,
  setList_representantes,
  dataCity,
  dataCityFilter,
  setDataCityFilter,
  loading,
  addRepresentante,
  editarRepresentante,
  handleChangeCidadeUf,
  editar,
  listRepresentante,
  loadingRepresentante,
}) => {
  const { data_cnpj, refetch } = useGetCnpj(cnpj?.replace(/[^\d]/g, ''))
  const { data_cep, refetch_cep } = useGetCep(cep.replace(/\D/g, ''))
  const [timeRenderizar, setTimeRenderizar] = useState<boolean>(true)

  const [dataUf, setDataUf] = useState([])
  const [dataCE, setDataCE] = useState([])
  const [dataEC, setDataEC] = useState([])
  const [dataPR, setDataPR] = useState([])
  const [equipe, setEquipe] = useState([])

  async function listarDadosSelects() {
    const resUF = await listUf()
    const resCE = await listEscolaridade()
    const resEC = await listEstadoCivil()
    const resPR = await listProfissao()

    setDataUf(resUF)
    setDataCE(resCE)
    setDataEC(resEC)
    setDataPR(resPR)
  }

  async function listarEquipeCliente() {
    const response: AxiosResponse<TypesEquipe> = await getEquipe({
      codCliente: update,
    })

    setEquipe(response?.data?.itens)
  }

  function normalizarObjeto(obj) {
    // Mapeamento dos campos do primeiro objeto
    if (obj?.cnpj) {
      return {
        cnpj: obj.cnpj,
        razao_social: obj.razao_social,
        nome_fantasia: obj.nome_fantasia || '',
        cep: obj.endereco?.cep || '',
        telefone: obj.telefone1 || '',
        email: obj.email || '',
        logradouro: obj.endereco?.logradouro || '',
        numero: obj.endereco?.numero || '',
        complemento: obj.endereco?.complemento || '',
        bairro: obj.endereco?.bairro || '',
        municipio: obj.endereco?.municipio || '',
        uf: obj.endereco?.uf || '',
      }
    }

    if (obj?.data?.['CNPJ']) {
      const ddd = obj?.data?.['DDD'] || ''
      const telefone = obj?.data?.['TELEFONE'] || ''
      // console.log(ddd + telefone)
      return {
        cnpj: obj?.data?.['CNPJ'] || '',
        razao_social: obj?.data?.['RAZAO SOCIAL'] || '',
        nome_fantasia: obj?.data?.['NOME FANTASIA'] || '',
        cep: obj?.data?.['CEP'] || '',
        telefone: ddd + '9' + telefone || '',
        email: obj?.data?.['EMAIL'] || '',
        logradouro: obj?.data?.['LOGRADOURO'] || '',
        numero: obj?.data?.['NUMERO'] || '',
        complemento: obj?.data?.['COMPLEMENTO'] || '',
        bairro: obj?.data?.['BAIRRO'] || '',
        municipio: obj?.data?.['MUNICIPIO'] || '',
        uf: obj?.data?.['UF'] || '',
      }
    }
  }

  const dadosCNPJ = normalizarObjeto(data_cnpj)

  useEffect(() => {
    if (data_cnpj !== undefined && dadosCNPJ !== undefined && tipo_cliente === 'J') {
      const uf = dataUf.filter((item) => item.sigla === dadosCNPJ?.uf)
      handleChangeCidadeUf(uf[0]?.cod)
      setEstado(uf[0]?.nome)
      setRazao_social(dadosCNPJ?.razao_social)
      setNome(dadosCNPJ?.nome_fantasia)
      setEmail(dadosCNPJ?.email)
      setCep(dadosCNPJ?.cep)
      setBairro(dadosCNPJ?.bairro)
      setLogradouro(dadosCNPJ?.logradouro)
      setNumero(dadosCNPJ?.numero)
      setComplemento(dadosCNPJ?.complemento)
    }
  }, [data_cnpj])

  useEffect(() => {

    let temDadosCnpj = data_cnpj !== undefined || data_cnpj?.data !== undefined ? true : false
    
    if (dataCityFilter?.length > 0 && data_cnpj !== undefined && !timeRenderizar) {
     
      const cidadeSemAcento = dataCityFilter?.map((item) => {
        return {
          ...item,
          nome: item.nome.normalize('NFD').replace(/[\u0300-\u036f]/g, ''),
        }
      })
      const cidade = cidadeSemAcento.filter(
        (item) => item.nome.toLowerCase() === dadosCNPJ?.municipio.toLowerCase()
      )

      setCidade(cidade[0]?.nome)
      setCidadeId(cidade[0]?.cod)
    }
  }, [dataCityFilter, data_cnpj])

  useEffect(() => {
    if (cnpj.replace(/[^\d]/g, '').length === 14 && tipo_cliente === 'J' && !timeRenderizar) {
      loadingAlert({ msg: 'Buscando CNPJ...', id: 'cnpj' })
      refetch()
    }
  }, [cnpj])

  useEffect(() => {
    if (cep?.length === 9 && !timeRenderizar) {
      loadingAlert({ msg: 'Buscando CEP...', id: 'cep' })
      refetch_cep()
    }
  }, [cep])

  useEffect(() => {
    if (data_cep !== undefined && !timeRenderizar) {
      if (data_cep.bairro !== '' && data_cep.logradouro !== '') {
        setBairro(data_cep.bairro)
        setLogradouro(data_cep.logradouro)
        const estadoFiltrado = dataUf?.filter((item) => item.nome === data_cep?.estado)
        handleChangeCidadeUf(estadoFiltrado[0]?.cod)
        setEstado(estadoFiltrado[0]?.nome)
        const cidadeFiltrado = dataCity?.filter(
          (item) => item.nome.toLowerCase() === data_cep?.localidade.toLowerCase()
        )
        setEstadoId(estadoFiltrado[0]?.cod)
        setCidadeId(cidadeFiltrado[0]?.cod)
        setCidade(data_cep.localidade)
      } else {
        const estadoFiltrado = dataUf?.filter((item) => item.nome === data_cep?.estado)
        handleChangeCidadeUf(estadoFiltrado[0]?.cod)
        setEstado(estadoFiltrado[0]?.nome)
        const cidadeFiltrado = dataCity?.filter(
          (item) => item.nome.toLowerCase() === data_cep?.localidade.toLowerCase()
        )
        setCidade(data_cep.localidade)
        setCidadeId(cidadeFiltrado[0]?.cod)
      }
    }
  }, [data_cep])

  useEffect(() => {
    listarDadosSelects()
  }, [])

  useEffect(() => {
    listarEquipeCliente()
  }, [])

  useEffect(() => {
    if (update <= 0) {
      setDataCityFilter([])
    }
  }, [update])

  useEffect(() => {
    setTimeout(() => {
      setTimeRenderizar(false)
    }, 2000)
  }, [])

  return (
    <>
      <HeaderDrawer>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          {update > 0 ? 'Atualizar cliente' : 'Cadastrar cliente'}

          {/* <small style={{ opacity: '0.5', fontSize: '9px' }}>{criadoPorAtualizadoPor}</small> */}
        </div>
      </HeaderDrawer>
      <BodyDrawer>
        <Render condition={loadingForm}>
          <Carregando
            animation
            justifyContent='center'
            height={'500px'}
            legenda='Carregando informações...'
          />
        </Render>
        <Render condition={loadingForm === false}>
          <Tabs
            tabs={[
              { descricao: 'Dados do cliente', icone: faUser },
              { descricao: 'Sociedade/Representantes', icone: faUsers, disabled: update <= 0 },
              { descricao: 'Módulos do cliente', icone: faGear, disabled: update <= 0 },
            ]}
            trackWidth={270}
            selecionado={tab_selecionado_atual}
            onChange={setTab_selecionado_atual}
          />
          <Render condition={tab_selecionado_atual === 'Dados do cliente'}>
            <FormDadosClientes
              tipo_cliente={tipo_cliente}
              setTipo_cliente={setTipo_cliente}
              nome={nome}
              setNome={setNome}
              dataNascimento={nascimento}
              setDataNascimento={setNascimento}
              cpf={cpf}
              setCpf={setCpf}
              rg={rg}
              setRg={setRg}
              orgao_expedidor={orgao_expedidor}
              setOrgao_expedidor={setOrgao_expedidor}
              sexo={sexo}
              setSexo={setSexo}
              nacionalidade={nacionalidade}
              setNacionalidade={setNacionalidade}
              escolaridade={escolaridade}
              setEscolaridade={setEscolaridade}
              escolaridadeId={escolaridadeId}
              setEscolaridadeId={setEscolaridadeId}
              estado_civil={estado_civil}
              setEstado_civil={setEstado_civil}
              estado_civilId={estado_civilId}
              setEstado_civilId={setEstado_civilId}
              profissao={profissao}
              setProfissao={setProfissao}
              profissaoId={profissaoId}
              setProfissaoId={setProfissaoId}
              celular={celular}
              setCelular={setCelular}
              fone_fixo={fone_fixo}
              setFone_fixo={setFone_fixo}
              email={email}
              setEmail={setEmail}
              estado={estado}
              setEstado={setEstado}
              estadoId={estadoId}
              setEstadoId={setEstadoId}
              cidade={cidade}
              setCidade={setCidade}
              cidadeId={cidadeId}
              setCidadeId={setCidadeId}
              cep={cep}
              setCep={setCep}
              logradouro={logradouro}
              setLogradouro={setLogradouro}
              numero={numero}
              setNumero={setNumero}
              bairro={bairro}
              setBairro={setBairro}
              complemento={complemento}
              setComplemento={setComplemento}
              razao_social={razao_social}
              setRazao_social={setRazao_social}
              cnpj={cnpj}
              setCnpj={setCnpj}
              ie={ie}
              setIe={setIe}
              uploadLogo={uploadLogo}
              handleChangeUpload={handleChangeUpload}
              dummyRequest={dummyRequest}
              onPreview={onPreview}
              fileListImg={fileListImg}
              onRemoveLogo={onRemoveLogo}
              previewVisibleImg={previewVisibleImg}
              setPreviewVisibleImg={setPreviewVisibleImg}
              imageUrl={imageUrl}
              outros={outros}
              setOutros={setOutros}
              dataEstados={dataUf}
              dataCidade={dataCity}
              dataCE={dataCE}
              dataEC={dataEC}
              dataPR={dataPR}
              handleChangeCidadeUf={handleChangeCidadeUf}
            />
          </Render>
          <Render condition={tab_selecionado_atual === 'Sociedade/Representantes'}>
            <FormRepresentantesServiço
              nome_usuario={nome_usuario}
              setNome_usuario={setNome_usuario}
              nome_usuarioId={nome_usuarioId}
              setNome_usuarioId={setNome_usuarioId}
              outros_solicitantes={outros_solicitantes}
              setOutros_solicitantes={setOutros_solicitantes}
              porcentagem={porcentagem}
              setPorcentagem={setPorcentagem}
              representante_legal={representante_legal}
              setRepresentante_legal={setRepresentante_legal}
              observacoes={observacoes}
              setObservacoes={setObservacoes}
              onChangeUpload={onChangeUpload}
              fileList={fileList}
              dummyRequest={dummyRequestAss}
              handlePreviewImage={handlePreviewImage}
              onRemoveAssinatura={onRemoveAssinatura}
              uploadAssinatura={uploadAssinatura}
              list_representantes={list_representantes}
              setList_representantes={setList_representantes}
              loading={loading}
              addRepresentante={addRepresentante}
              editarRepresentante={editarRepresentante}
              dataEquipe={equipe}
              update={update}
              editar={editar}
              listRepresentante={listRepresentante}
              loadingRepresentante={loadingRepresentante}
            />
          </Render>
          <Render condition={tab_selecionado_atual === 'Módulos do cliente'}>
            <ClienteModulo statusCliente={statusCliente} codCliente={clienteSelect} />
          </Render>
        </Render>
      </BodyDrawer>
    </>
  )
}
